import { render, staticRenderFns } from "./ruleCustomer.vue?vue&type=template&id=13133dcf&scoped=true&"
import script from "./ruleCustomer.vue?vue&type=script&lang=js&"
export * from "./ruleCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13133dcf",
  null
  
)

export default component.exports